import "./styles.css";
import { Chips } from "../chips/chips";

const statuses = {
  projectAdmin: 'Project admin',
  projectManager: 'Site manager',
  user: 'User',
  admin: 'Organization admin',
  systemAdmin: 'System admin',
  invited: "Invited",
  inviteError: "Invitation error",
  confirmed: "Active",
  activeCopy: "Active",
  active: "Active",
  blocked: "Blocked",
  inactive: "Inactive",
  onboarding: "Pending",
  PENDING: "Pending",
  pending: "Pending changes",
  COMPLETE: "Complete",
  COMPLETED: "Complete",
  INCOMPLETED: "Incomplete",
  IN_PROGRESS: "In progress",
  OVERDUE: "Overdue",
  DISMISSED: "Dismissed",
};

const getColor = (status) => {
  switch (status) {
    case "IN_PROGRESS":
    case "invited":
    case "PENDING":
    case "pending":
    case "onboarding":
      return "yellow";
    case "inviteError":
    case "OVERDUE":
    case "DISMISSED":
    case "blocked":
      return "red";
    case "activeCopy":
    case "confirmed":
    case "active":
    case "COMPLETE":
    case "COMPLETED":
      return "green";
    case "inactive":
    case "INCOMPLETED":
      return "grey";
    default:
      return "grey";
  }
};

// `text` overrides the label: a project role shows the name it has now (roles
// can be renamed, and custom ones have no entry here — LF360-2024).
const UserActivityStatus = ({ userStatus, text, fontSize, style }) => (
  <Chips
    text={text || statuses[userStatus]}
    color={getColor(userStatus)}
    fontSize={fontSize}
    borderColor={getColor(userStatus)}
    style={style}
  />
);
export default UserActivityStatus;
